import { useSessionContext } from 'supertokens-auth-react/recipe/session';
import { UserRoleClaim } from 'supertokens-auth-react/recipe/userroles';

export interface AuthState {
    /** True until SuperTokens has resolved whether a session exists. */
    loading: boolean;
    loggedIn: boolean;
    /** SuperTokens user id; scopes per-user query cache keys (queries/users.ts). */
    userId: string | undefined;
    roles: string[];
    isAdmin: boolean;
    /** api_user or admin -- the same rule lib/ApiUserRoute.tsx enforces. */
    canAccessDeveloper: boolean;
}

// The one place the UI decides who is logged in and which roles they hold, for
// anything that only needs to *show or hide* a link. Reads the "st-role" claim
// straight off the access-token payload, so it costs no extra request and
// agrees with itself on first render. Route protection still goes through
// AdminRoute / ApiUserRoute, which validate the claim properly.
export function useAuthState(): AuthState {
    const session = useSessionContext();

    if (session.loading) {
        return {
            loading: true,
            loggedIn: false,
            userId: undefined,
            roles: [],
            isAdmin: false,
            canAccessDeveloper: false
        };
    }

    const roles: string[] = session.doesSessionExist
        ? UserRoleClaim.getValueFromPayload(session.accessTokenPayload) || []
        : [];
    const isAdmin = roles.includes('admin');

    return {
        loading: false,
        loggedIn: session.doesSessionExist,
        userId: session.doesSessionExist ? session.userId : undefined,
        roles,
        isAdmin,
        canAccessDeveloper: isAdmin || roles.includes('api_user')
    };
}
